import { createFileRoute, redirect, useSearch } from '@tanstack/react-router';
import { Permission } from '../../../features/auth';
import { VerifyAssetsPage } from '../../../features/case-schedule/verify-assets';

export const Route = createFileRoute('/_auth/case-schedule/case-detail')({
  staticData: {
    title: 'pages.caseVerifyAssets.title',
    description: 'pages.caseVerifyAssets.description',
  },
  validateSearch: (search: Record<string, unknown>) => ({
    caseId: (search.caseId as string | undefined) ?? undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const { isAuthenticated, hasPermission, isAdmin } = context.auth;
    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.OR_NURSE) && !isAdmin())
      throw redirect({ to: '/403' });

    const caseId = search.caseId as string | undefined;
    if (!caseId) throw redirect({ to: '/case-schedule' });
  },
  component: CaseDetailRoute,
});

function CaseDetailRoute() {
  const { caseId } = useSearch({ from: '/_auth/case-schedule/case-detail' });
  return <VerifyAssetsPage caseId={caseId as string} />;
}
